/*** Created by qfintern on 18/04/2018  ***/
import storage from 'store';

const localStorage = Object.freeze({
    saveInStorage: (type, state) => storage.set(type, state),
    removeFromStorage: type => storage.remove(type),
    getFromStorage: type => storage.get(type),

    saveUsername: username => storage.set('username', username),
    saveUsernameRole: role => storage.set('role', role),

    getUsername: () => storage.get('username'),
    getUsernameRole: () => storage.get('role'),

    removeUsername: () => storage.remove('username'),
    removeUsernameRole: () => storage.remove('role'),

    saveToken: (type, token) => storage.set(type, token),
    getToken: type => storage.get(type),
    removeToken: type => storage.remove(type)
});

export default localStorage;





// WEBPACK FOOTER //
// ./src/customModules/Common/LocalStorage.js